import Lottie from 'lottie-react'
import notFoundAnimation from '@/assets/Lottie/Empty State.json'

export default function SearchNotFoundAnimation() {
  return (
    <div>
      <Lottie animationData={notFoundAnimation} style={{ width: 200 }} loop={false} />
    </div>
  )
}
